import React from 'react'
import { Home, Car, Smartphone, BarChart2, Users, Map, Settings, Building2, UserCheck, CheckCircle, ScreenShare, SquareParking, Cctv, LayoutGrid, Bus, Route } from 'lucide-react'
import { translations } from '../../utils/constants'
import allPaths from '../../Config/paths'

// Single source of truth for the navigation, shared by the desktop SideMenu
// and the MobileMenu. Items carry an optional `show` flag; groups whose items
// are all hidden are dropped so no empty header is rendered.
export const getMenuGroups = ({ language, user }) => {
    const t = translations[language] || {}

    const groups = [
        {
            key: 'overview',
            label: t.menuGroupOverview,
            items: [
                {
                    title: t.dashboard,
                    route: allPaths?.HOME,
                    icon: <Home size={20} />
                },
                {
                    title: t.map,
                    route: allPaths?.MAP,
                    icon: <Map size={20} />
                },
            ]
        },
        {
            key: 'fleet',
            label: t.menuGroupFleet,
            items: [
                {
                    title: t.vehicles,
                    route: allPaths?.VEHICLES,
                    activePaths: [allPaths?.VEHICLES, '/vehicles-details'],
                    icon: <Car size={20} />
                },
                {
                    title: t.gtfs,
                    route: allPaths?.GTFS,
                    activePaths: [allPaths?.GTFS, '/gtfs-details'],
                    icon: <Bus size={20} />
                },
                {
                    title: t.devices,
                    route: allPaths?.DEVICES,
                    icon: <Smartphone size={20} />
                },
                {
                    title: t.routeHistory,
                    route: allPaths?.ROUTE_HISTORY,
                    icon: <Route size={20} />
                },
            ]
        },
        {
            key: 'analytics',
            label: t.menuGroupAnalytics,
            items: [
                {
                    title: t.reports,
                    route: allPaths?.REPORTS,
                    icon: <BarChart2 size={20} />
                },
                {
                    title: t.peopleCountertxt,
                    route: allPaths?.PEOPLE_COUNTER,
                    icon: <UserCheck size={20} />
                },
            ]
        },
        {
            key: 'parking',
            label: t.menuGroupParking,
            items: [
                {
                    title: t.parking,
                    route: allPaths?.PARKING,
                    icon: <SquareParking size={20} />,
                    show: user?.role !== 'user'
                },
                {
                    title: t.cameraMappings,
                    route: allPaths?.CAMERA_MAPPING,
                    icon: <Cctv size={20} />,
                    show: user?.role !== 'user'
                },
                {
                    title: t.parkinglotsHeading,
                    route: allPaths?.MANAGE_PARKING_LOTS,
                    icon: <LayoutGrid size={20} />,
                    show: user?.role === 'superAdmin'
                },
            ]
        },
        {
            key: 'admin',
            label: t.menuGroupAdmin,
            items: [
                {
                    title: t.organizations,
                    route: allPaths?.ORGANIZATION,
                    icon: <Building2 size={20} />,
                    show: user?.role === 'superAdmin'
                },
                {
                    title: t.users,
                    route: allPaths?.USERS,
                    icon: <Users size={20} />,
                    show: user?.role !== 'user'
                },
                {
                    title: t.validator,
                    route: allPaths?.VALIDATOR,
                    icon: <CheckCircle size={20} />,
                    show: user?.role === 'superAdmin'
                },
                {
                    title: t.panelList,
                    route: allPaths?.LED_SCREEN,
                    icon: <ScreenShare size={20} />,
                    show: user?.role === 'superAdmin'
                },
            ]
        },
        {
            key: 'system',
            label: t.menuGroupSystem,
            items: [
                {
                    title: t.settingHeading,
                    route: allPaths?.SETTINGS,
                    icon: <Settings size={20} />
                },
            ]
        },
    ]

    return groups
        .map((g) => ({
            ...g,
            items: g.items.filter((item) => (item.hasOwnProperty('show') ? item.show : true))
        }))
        .filter((g) => g.items.length > 0)
}

export const isMenuItemActive = (item, pathname) => {
    if (item?.activePaths) {
        return item.activePaths.some((p) => p && pathname?.startsWith(p))
    }
    return pathname === item?.route
}
